import {lazy} from 'react';

const CampaignList = lazy(() => import('./CampaignList'));

export default CampaignList;
